import React from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartOptions,
    TimeScale,
} from "chart.js";
import 'chartjs-adapter-date-fns';

ChartJS.register(LinearScale, CategoryScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale);

interface AppealTrendChartProps {
    data: {
        horizontalStart: string;
        HorizontalEnd: string;
        verticalSize: number;
        points: {
            problem_lvl_low: { horizontal: string; vertical: number }[];
            problem_lvl_mid: { horizontal: string; vertical: number }[];
            problem_lvl_standart: { horizontal: string; vertical: number }[];
            problem_lvl_high: { horizontal: string; vertical: number }[];
            problem_lvl_critical: { horizontal: string; vertical: number }[];
        };
    };
}

const AppealTrendChart: React.FC<AppealTrendChartProps> = ({ data }) => {

    if (!data || !data.points) {
        return <p>Загрузка данных...</p>; 
    }

    const uniqueDates = new Set<string>();

    Object.values(data.points).forEach(levelPoints => {
        levelPoints.forEach(point => {
            uniqueDates.add(point.horizontal);
        });
    });

    const labels =transformDates(sortDates(Array.from(uniqueDates)))


    const getDataPoints = (level: keyof typeof data.points) => {
        return labels.map(label => {
            const point = data.points[level].find(p => transformDate(p.horizontal) === label);
            return point ? point.vertical : 0;
        });
    };

    const chartData = {
        labels,
        datasets: [
            {
                label: "Низкая",
                data: getDataPoints("problem_lvl_low"),
                borderColor: "rgba(75, 192, 192, 1)",
                fill: false,
            },
            {
                label: "Средняя",
                data: getDataPoints("problem_lvl_mid"),
                borderColor: "rgba(153, 102, 255, 1)",
                fill: false,
            },
            {
                label: "Стандартная",
                data: getDataPoints("problem_lvl_standart"),
                borderColor: "rgba(255, 206, 86, 1)",
                fill: false,
            },
            {
                label: "Высокая",
                data: getDataPoints("problem_lvl_high"),
                borderColor: "rgba(255, 99, 132, 1)",
                fill: false,
            },
            {
                label: "Критическая",
                data: getDataPoints("problem_lvl_critical"),
                borderColor: "rgba(255, 159, 64, 1)",
                fill: false,
            },
        ],
    };
    const options: ChartOptions<'line'> = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: "Количество обращений по уровню критичности",
            },
        },
        scales: {
            x: {
                type: 'time',
                time: {
                    unit: 'day',
                },
                max:transformDate(data.HorizontalEnd),
                title: {
                    display: true,
                    text: "Дата",
                },
            },
            y: {
                title: {
                    display: true,
                    text: "Количество обращений",
                },
                min: 0,
                max: data.verticalSize,
            },
        },
    };


    return <Line data={chartData} options={options} />;
};

export default AppealTrendChart;

function sortDates(dates: string[]): string[] {
    return dates.sort((a, b) => {
        const [dayA, monthA, yearA] = a.split('.').map(Number);
        const [dayB, monthB, yearB] = b.split('.').map(Number);

        const dateA = new Date(yearA, monthA - 1, dayA);
        const dateB = new Date(yearB, monthB - 1, dayB);

        return dateA.getTime() - dateB.getTime();
    });
}
function transformDate(date: string): string {
    const [day, month, year] = date.split('.').map(Number);
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

function transformDates(dates: string[]): string[] {
    return dates.map(transformDate);
}